import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b01ed08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-details-card" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text-main" }
const _hoisted_4 = { class: "text-title" }
const _hoisted_5 = { class: "text-content" }
const _hoisted_6 = { class: "text-msg" }
const _hoisted_7 = {
  key: 1,
  class: "img-box"
}
const _hoisted_8 = { class: "img-content" }
const _hoisted_9 = {
  key: 2,
  class: "logistics-trajectory"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Track Package", -1))


import AfterGoodsCard from './afterGoodsCard.vue';
import { Toast } from 'vant';

export default /*#__PURE__*/_defineComponent({
  __name: 'afterDetailsCard',
  props: {
    /** 售后单操作记录模块 */
    detailData: {
        type: Array,
        default: () => []
    },
    /** 是否可以编辑用户退换货发货方式的地址 */
    isEditAddress: {
        type: Boolean,
        default: false
    },
},
  emits: ['logistics'],
  setup(__props, { emit }) {

const prop = __props



const handleBtn = (item: any, type: string) => {
    emit('logistics', item, type)

}
// 复制售后服务号
const handleCopy = (text:any) => {
    let input = document.createElement("input");   // 直接构建input
        input.value = text;  // 设置内容
        document.body.appendChild(input);    // 添加临时实例
        input.select();   // 选择实例内容
        document.execCommand('copy') ? Toast('replicated') : ''; 
        document.body.removeChild(input); 
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detailData, (item) => {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(item.title), 1),
      (item.goodsData)
        ? (_openBlock(), _createBlock(AfterGoodsCard, {
            key: 0,
            goodsData: item.goodsData
          }, null, 8, ["goodsData"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.textData, (text) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(text.label) + ":", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(text.value), 1),
            (text.label === 'Service No.')
              ? (_openBlock(), _createBlock(_component_van_icon, {
                  key: 0,
                  name: "https://image.kilimall.com/kenya/wap/afterSales/copy_2x.png",
                  color: "#46BA64",
                  onClick: ($event: any) => (handleCopy(text.value))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 256)),
      (item.fileList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileList, (file) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_van_image, {
                  width: "1.38rem",
                  height: "1.38rem",
                  src: file.content,
                  fit: "cover"
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      (item.transit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "logistics-btn",
              onClick: ($event: any) => (handleBtn(item.transit,'look'))
            }, [
              _createVNode(_component_van_icon, {
                name: "https://image.kilimall.com/kenya/wap/afterSales/icon_shipping_2x.png",
                color: "#46BA64"
              }),
              _hoisted_11
            ], 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 256))
}
}

})